import type { DisplayState } from "../state.js";
import { StatusLabel } from "./StatusLabel.js";
import { Orb } from "./Orb.js";
import type { ResolvedOrbPalette } from "../orbPalette.js";

export interface HeaderProps {
  displayState: DisplayState;
  strings: Record<DisplayState, string>;
  showOrb?: boolean;
  palette?: ResolvedOrbPalette;
}

export function Header({ displayState, strings, showOrb, palette }: HeaderProps) {
  return (
    <div class="va-header">
      <div class="va-header-status">
        {showOrb ? <Orb displayState={displayState} palette={palette} /> : null}
        <StatusLabel displayState={displayState} strings={strings} />
      </div>
    </div>
  );
}
